<template>
  <v-container class="modern-config-view pb-12">
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white">fas fa-sliders-h</v-icon>
        </v-avatar>
        <div>
          <h1 class="text-h4 font-weight-black primary--text mb-0">Control de <span class="secondary--text">Parámetros</span></h1>
          <div class="caption grey--text font-weight-bold text-uppercase tracking-widest mt-1">Configuración global del ecosistema Runflow</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-bind="attrs" v-on="on"
              text color="error" 
              class="rounded-lg text-none font-weight-bold mr-2"
              @click="cleanWorkOrders"
            >
              <v-icon left small>fas fa-broom</v-icon> Limpiar Errores OT
            </v-btn>
          </template>
          <span>Limpia estados inconsistentes en órdenes de trabajo</span>
        </v-tooltip>
      </div>
    </v-row>

    <v-card outlined class="modern-card elevation-0 overflow-hidden shadow-sm">
      <!-- Main Configuration is handled inside Company component currently -->
      <company />
    </v-card>
  </v-container>
</template>

<script>
import Company from '@/components/parameters/Company'
import { cleanWorkOrders } from '@/api/production'
import notifications from '@/utils/notifications'

export default {
  name: 'ParametersManager',
  components: { Company },
  data: () => ({
    tab: 0,
  }),
  methods: {
    async cleanWorkOrders() {
      try {
        await cleanWorkOrders()
        notifications.showSuccess('Proceso completado', 'Las inconsistencias en OTs han sido corregidas')
      } catch (e) {
        notifications.showError('Error al limpiar OTs', e)
      }
    }
  }
}
</script>

<style scoped>
.modern-config-view { background-color: #f4f7f9; min-height: 100vh; }
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
  background-color: white !important;
}
.tracking-widest { letter-spacing: 2px; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; }
.border-white-sm { border: 2px solid white !important; }
</style>